import React from 'react';
import './CookiePolicy.scss';

function CookiePolicy() {
  return (
    <div className="body-container cookie-container">
      <button id="ot-sdk-btn" class="ot-sdk-show-settings">
        Cookie Settings
      </button>
      <div id="ot-sdk-cookie-policy"></div>
    </div>
  );
}

export default CookiePolicy;
